__turbopack_context__.v({
  "profile-photo": "MjfYEa_profile-photo",
  "profile-photo--has-border": "MjfYEa_profile-photo--has-border",
  "profile-photo--is-fluid": "MjfYEa_profile-photo--is-fluid",
  "profile-photo--large": "MjfYEa_profile-photo--large",
  "profile-photo--xsmall": "MjfYEa_profile-photo--xsmall",
  "profile-photo__content": "MjfYEa_profile-photo__content",
  "profile-photo__content--hover": "MjfYEa_profile-photo__content--hover",
  "profile-photo__icon": "MjfYEa_profile-photo__icon",
  "profile-photo__image": "MjfYEa_profile-photo__image",
});
